import { Record } from 'immutable';
import { AccountService } from '@sm360/widget-commons-general';

import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';

import { AVAILABILITY_FLAGS, UPDATE_STATUS } from 'commons-vehicle/Vehicle/constants/tradeInVehicleStatuses.js';

const TradeInVehicleRecord = Record({
    id: '',
    status: 0,
    accountId: '',
    dealerId: '',
    taxesFactor: 0,
    taxCodes: [],
    vehicle: new VehicleModel(),
    lien: {
        owner: '',
        amount: 0,
    },
    amount: 0,
    evaluationQuestion: null,
    modified: false,
});

class TradeInVehicle extends TradeInVehicleRecord {
    getTradeInAmount() {
        return this.amount;
    }

    getLienAmount() {
        return this.lien.amount;
    }

    getShowroomTradeInVehicle() {
        const { id, status, lien, amount, evaluationQuestion } = this;
        const showroomVehicle = this.vehicle.getShowroomVehicle();

        return {
            id,
            status,
            vehicle: showroomVehicle,
            lien,
            amount,
            evaluationQuestion,
        };
    }

    getUpdateStatus() {
        if ((this.status & UPDATE_STATUS.OFFICIAL_EXPIRED) === UPDATE_STATUS.OFFICIAL_EXPIRED) {
            return UPDATE_STATUS.OFFICIAL_EXPIRED;
        } else if ((this.status & UPDATE_STATUS.OFFICIAL) === UPDATE_STATUS.OFFICIAL) {
            return UPDATE_STATUS.OFFICIAL;
        } else if ((this.status & UPDATE_STATUS.ESTIMATED_EXPIRED) === UPDATE_STATUS.ESTIMATED_EXPIRED) {
            return UPDATE_STATUS.ESTIMATED_EXPIRED;
        } else if ((this.status & UPDATE_STATUS.ESTIMATED) === UPDATE_STATUS.ESTIMATED) {
            return UPDATE_STATUS.ESTIMATED;
        } else if (
            (this.status & UPDATE_STATUS.DESCRIBED) === UPDATE_STATUS.DESCRIBED &&
            (this.status & AVAILABILITY_FLAGS.DELETED) === 0
        ) {
            return UPDATE_STATUS.DESCRIBED;
        }
        return UPDATE_STATUS.ACTIVATED;
    }

    checkIsLocked() {
        const updateStatus = this.getUpdateStatus();
        return updateStatus !== UPDATE_STATUS.DESCRIBED && updateStatus !== UPDATE_STATUS.ACTIVATED;
    }

    checkIsUpdatable() {
        return AccountService.isAuthenticated() && !this.checkIsLocked() && this.id && this.modified;
    }

    getTaxCredits() {
        return Math.round(this.amount * this.taxesFactor * 100) / 100;
    }
}

export default TradeInVehicle;
